// react
import { createContext } from 'react';

// types
import type { ShortcutContextProps } from './ShortcutProvider.types';

export const ShortcutContext = createContext<ShortcutContextProps>({
  enableShortcut: undefined,
  disableShortcut: undefined,
  register: undefined,
  unregister: undefined,
  pushNarrowing: undefined,
  popNarrowing: undefined
});
